<div class="p-6">
  <app-table
  [config]="pricingTableConfig"
  [data]="pricingTableData"
  [(selectedElements)]="selectedElements"
  >
  </app-table>
</div>
